import { FormLabel as FL, FormLabelProps } from '@chakra-ui/react';
import fp from 'lodash/fp';

export const FormLabel: React.FC<FormLabelProps> = (
  props,
): JSX.Element | null => {
  const { children, htmlFor, size, ...rest } = props;

  if (fp.isEmpty(children) || fp.isNil(children)) return null;

  return (
    <FL fontSize={size || 'md'} htmlFor={htmlFor} {...rest}>
      {children}
    </FL>
  );
};

FormLabel.defaultProps = {
  color: 'blackAlpha.600',
  fontWeight: 'medium',
};
